import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36dcf757"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "simple_hero" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = {
    key: 0,
    class: "text-primary"
};
const _hoisted_4 = {
    key: 1,
    class: "mt-4"
};
const _hoisted_5 = {
    key: 2,
    class: "mt-4 repeatable_cta"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'simple_hero',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_arrow_link = _resolveComponent("arrow-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (__props.d.line_one)
                        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.d.line_one), 1))
                        : _createCommentVNode("", true),
                    (__props.d.line_two)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(__props.d.line_two), 1))
                        : _createCommentVNode("", true),
                    (__props.d.repeatable_cta.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.repeatable_cta, (link) => {
                                return (_openBlock(), _createBlock(_component_arrow_link, {
                                    hasAnimation: false,
                                    link: link.cta_link,
                                    text: link.cta_title,
                                    small: true,
                                    centreAlign: true
                                }, null, 8, ["link", "text"]));
                            }), 256))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
